import { render, staticRenderFns } from "./TutorialesTurnos.vue?vue&type=template&id=37bf2d94&scoped=true"
import script from "./TutorialesTurnos.vue?vue&type=script&lang=js"
export * from "./TutorialesTurnos.vue?vue&type=script&lang=js"
import style0 from "./TutorialesTurnos.vue?vue&type=style&index=0&id=37bf2d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bf2d94",
  null
  
)

export default component.exports